import { configureStore } from '@reduxjs/toolkit';

import themeReducer from './slice/themeSlice';
import userReducer from './slice/userSlice';
import linksReducer from './slice/linksSlice';


export const store = configureStore({
    reducer: {
        theme: themeReducer,
        user: userReducer,
        links: linksReducer
    }
}); 